import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["disabled", "variant"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button, LayoutHorizontal } from 'breeze-intelligence-kit';
import { BreezeRegenerateIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ButtonRegenerate(_ref) {
  let {
      disabled,
      variant = 'link'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const color = disabled ? 'disabled' : 'base';
  return /*#__PURE__*/_jsx(Button, Object.assign({}, rest, {
    disabled: disabled,
    variant: variant,
    children: /*#__PURE__*/_jsxs(LayoutHorizontal, {
      color: color,
      gap: "space-xxs",
      paddingInline: "space-sm",
      children: [/*#__PURE__*/_jsx(BreezeRegenerateIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "smartPropertyTemplates.regenerate"
      })]
    })
  }));
}